export class Utility {
  /**
    	SYNOPSIS:	Generate a UUID
    	PARAMETERS:	none
    	RETURNS:	a 36 byte, all-lowercase UUID
    */
  uuid = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0, // eslint-disable-line no-bitwise
        v = c == 'x' ? r : (r & 0x3) | 0x8; // eslint-disable-line no-bitwise
      return v.toString(16);
    });
  };

  /**
    	SYNOPSIS:	Rounds a numerical value to 2 decimals
    	PARAMETERS:	number
    	RETURNS:	input parameter rounded to 2 decimals
    */
  round2 = (original) => {
    return Math.round(original * 100) / 100;
  };

  /**
    	SYNOPSIS:	Rounds a numerical value to an int
    	PARAMETERS:	number
    	RETURNS:	input parameter rounded to the nearest whole number
    */
  round0 = (original, down) => {
    if (down) {
      if (original > 0) {
        // Positive numbers
        return Math.floor(original);
      } else {
        // Negative numbers
        return Math.ceil(original);
      }
    }
    return Math.round(original);
  };

  /**
    	SYNOPSIS:	Rounds a numerical value to 5 cents
    	PARAMETERS:	number
    	RETURNS:	input parameter rounded to 5 cents
    */
  roundTo5Cent = (amount) => {
    // Round to the second decimal fraction
    amount = Math.round(amount * Math.pow(10, 2)) / Math.pow(10, 2);

    let cents = amount % 0.1;
    // Round to the second decimal fraction
    cents = Math.abs(cents);
    cents = Math.round(cents * Math.pow(10, 2)) / Math.pow(10, 2);

    if (0 < cents && cents <= 0.02) {
      amount = amount < 0 ? amount + cents : amount - cents;
    } else if (0.03 <= cents && cents <= 0.07) {
      amount = amount < 0 ? amount + cents - 0.05 : amount - cents + 0.05;
    } else if (0.08 <= cents && cents < 0.1) {
      amount = amount < 0 ? amount + cents - 0.1 : amount - cents + 0.1;
    }
    // Round to the second decomil fraction
    amount = Math.round(amount * Math.pow(10, 2)) / Math.pow(10, 2);

    return amount;
  };

  /**
    	SYNOPSIS:	Generate a string of random alphanumeric characters
    	PARAMETERS:	_length = length of output string; defaults to 4
    			_characterset = characterset to use;
    				0 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
    				1 = "0123456789abcdefghijklmnopqrstuvwxyz"
    				2 = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"
    				3 = "0123456789ABCDEF" ==> HEX
    				4 = "0123456789" ==> DEC
            5 = Symbols
    				a string will be used as a literal characterset
    				defaults to 0
    	RETURNS:	a string of <_length> random alphanumeric characters
    */
  generateRandomAlphaNumeric = (_length, _chars) => {
    if (!_chars || _chars === 0) {
      _chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    } else {
      switch (_chars) {
        case 1:
          _chars = '0123456789abcdefghijklmnopqrstuvwxyz';
          break;
        case 2:
          _chars =
            '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
          break;
        case 3:
          _chars = '0123456789ABCDEF';
          break;
        case 4:
          _chars = '0123456789';
          break;
        case 5:
          _chars = '!#()*+-.';
          break;
      }
    }
    if (typeof _chars !== 'string') {
      return '';
    }
    const _charsetLength = _chars.length;
    let _randomstring = '';
    for (let i = 0; i < _length; i++) {
      const rnum = Math.floor(Math.random() * _charsetLength);
      _randomstring += _chars.substring(rnum, rnum + 1);
    }
    return _randomstring;
  };

  /**
    	SYNOPSIS:	Generate a string of random 5 hex digits
    	PARAMETERS:	none
    	RETURNS:	a string of random 5 hex digits
    */
  generateRefID = () => {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  };

  objectToArray = (object) => {
    const a = [];
    for (const i in object) {
      a.push({
        key: i,
        value: object[i],
      });
    }
    return a;
  };

  /** A function to create a link to another data object:
   * @param {String} resource the collection the other object is stored in
   * @param {String} id the id of the other object
   * @param {String} [type] an arbitrary type value
   * @param {String} [comment] any string value
   */
  link = (resource, id, type, comment) => {
    const l = {
      resource: resource,
      id: id,
    };
    if (comment) {
      // @ts-ignore
      l.comment = comment;
    }
    if (type) {
      // @ts-ignore
      l.type = type;
    }
    return l;
  };
}

/**
	SYNOPSIS:	A service with multiple utilities that can be used accross the application
  */
angular.module('v6CoreModule').factory('utility', () => {
  return new Utility();
});
